<script setup lang="ts">
  defineProps<{
    message: string,
    icon: string,
  }>()
</script>

<template>
  <div class="py-20 text-center">
    <div class="mb-8">
      <fa-icon
        :icon="icon"
        class="text-primary-500"
        size="5x" />
    </div>
    <div class="text-center text-lg text-gray-500 font-bold">
      {{ message }}
    </div>
  </div>
</template>
